import { HistoryAO } from "types/HistoryAO"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const historyAOReducer: RemoteReducer<HistoryAO[]> =
  createRemoteReducer("historyAO")
